import plugin_vue3_A0OWXRrUgq from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/mnt/data/maitop/robo-nation/code/platforms/web/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import composition_sLxaNGmlSL from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import payload_client_yVLowv6hDl from "/mnt/data/maitop/robo-nation/code/platforms/web/node_modules/nuxt/dist/app/plugins/payload.client.js";
import error_handling_1fblBAeRbR from "/mnt/data/maitop/robo-nation/code/platforms/web/plugins/error-handling.js";
import vuetify_7h9QAQEssH from "/mnt/data/maitop/robo-nation/code/platforms/web/plugins/vuetify.ts";
export default [
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  payload_client_yVLowv6hDl,
  error_handling_1fblBAeRbR,
  vuetify_7h9QAQEssH
]